import React, { Component } from 'react'
import DocsCatg from './DocsCatg'
import DocsPost from './DocsPost'
import DocsEdit from './DocsEdit'
import './style.css'
import bgImg from './docs.png'

export default class Docs extends Component {

	state = { 
        isEdit : false,
        catg : ''
    }


    editFx = (val) => {

        if(val === 'new') {

            this.setState({
                catg : '',
                isEdit : true
            }) 

        } else {

            this.setState({
                catg : val,
                isEdit : true
            }) 
        }
    }

    catgFx = (val) => {

        this.setState({
            catg : val,
            isEdit : false
        })

        const Catg = document.getElementById('DocsCatg')

        if(this.props.isMobile && Catg.style.width === '100%') {

            Catg.style.width = '0%'
            
        }

    }

    cancelFx = () => {

        this.setState({
            catg : '',
            isEdit : false
        })
    }

    openFx = () => {

        const Catg = document.getElementById('DocsCatg')

        if(Catg.style.width === '100%') {

            Catg.style.width = '0%'

        } else {

            Catg.style.width = '100%'

        }

    }

    render() {

        const bgStyle = {
            backgroundImage: this.props.isMobile ? 'none' : 'url(' + bgImg + ')',
            backgroundRepeat: 'no-repeat',
            height : '400px'
        }

        const Mmenu = () => {
            
            return(

                <div id='DocsMMenu' onClick={this.openFx}>

                    <i className='material-icons'>subject</i>

                </div>
            )
        }


        return (

            <div style = { bgStyle } >

                { this.props.isMobile ? <Mmenu /> : null }

                <div id = 'DocsPost'>

                    { this.state.isEdit ?
                        <DocsEdit catg = { this.state.catg } cancelMe = { this.cancelFx } /> : 
                        <DocsPost isEdit = { (val) => this.editFx(val) } catg = { this.state.catg } isLogin = { this.props.isLogin } />
                    }

                </div>

                <div id = 'DocsCatg'>

                    <DocsCatg catgFx = { (catg) => this.catgFx(catg) } />
                
                </div>

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/docs/index.js